import Vue from 'vue';

export default {
    getAnnualSalary(context) {
        return context.dispatch('getBands', { code: 'annual_salary' });
    },

    getHourlyRate(context) {
        return context.dispatch('getBands', { code: 'hourly_rate' });
    },

    getBands(context, data) {
        let url = `v1/pay-types/bands?code=${data.code}`;
        if (data.mode) {
            url += `&mode=${data.mode}`;
        }
        return Vue.$axios.$get(url);
    },
};
